import { api } from "../services/Api";

export default async function salvaHistoricoLog(
  acao,
  pedido,
) {
  const usuario = localStorage.getItem("@DNACenter:codigoUsuario");
  try {
    await api.post("/v2/coleta/coletaLog", {
      pedido: String(pedido || ""),
      usuario: String(usuario || ""),
      acao: String(acao || ""),
    });
  } catch (error) {
    console.error("Erro ao salvar log:", error);
  }
}